// Brand carousel data
export const brandCarousels = [
  {
    id: 1,
    brandName: 'Jack&Jones',
    brandUrl: 'https://www.jackjones.in/collections/jj-all-product?utm_source=GH_Google_Pmax&utm_medium=Paid&utm_campaign=Mixed_AllProducts-22691501712&gad_source=1&gad_campaignid=22691511810&gbraid=0AAAAACU3RmBUaubucu7ndaVhOy53fvlBM&gclid=CjwKCAiA7LzLBhAgEiwAjMWzCLbF5odqylET9gZHUV-_8K_iaGrnDD3zgkg3Lu71oyCo98PWjfJiaRoCfAkQAvD_BwE',
    description: 'Visual language across e-commerce, social platforms, and retail. Creating repeatable styling systems that translate global brand identity into locally resonant imagery.',
    images: [
      'https://customer-assets.emergentagent.com/job_fashion-narrative-2/artifacts/70mp6uzn_jj_2.jpg',
      'https://customer-assets.emergentagent.com/job_fashion-narrative-2/artifacts/sslekezv_jj_3.jpg',
      'https://customer-assets.emergentagent.com/job_fashion-narrative-2/artifacts/kpv17rd1_jj_4.jpg',
      'https://customer-assets.emergentagent.com/job_fashion-narrative-2/artifacts/jmwjly27_jj_5.jpg',
      'https://customer-assets.emergentagent.com/job_fashion-narrative-2/artifacts/sk7ugdft_jj_6.jpg'
    ]
  },
  {
    id: 2,
    brandName: 'Selected',
    brandUrl: 'https://www.selectedhomme.in/collections/sl-all-product?gad_source=1&gad_campaignid=23381581138&gclid=CjwKCAiA7LzLBhAgEiwAjMWzCBtPG4BZC6iPy2WLiw5WAOss8SETbFISob88JmVA7Fx9NcNZ5NYrZBoCL_sQAvD_BwE',
    description: 'Premium menswear styling with sophisticated aesthetic. Curating elevated looks that balance modern trends with timeless elegance.',
    images: [
      'https://customer-assets.emergentagent.com/job_fashion-narrative-2/artifacts/pcm8ellw_selected_1.jpg',
      'https://customer-assets.emergentagent.com/job_fashion-narrative-2/artifacts/kvone6ah_selected_2.jpg',
      'https://customer-assets.emergentagent.com/job_fashion-narrative-2/artifacts/k291lwmg_selected_4.jpg',
      'https://customer-assets.emergentagent.com/job_fashion-narrative-2/artifacts/g6hmqkhn_selected_6.jpg',
      'https://customer-assets.emergentagent.com/job_fashion-narrative-2/artifacts/j66fkm35_selected_9.jpg',
      'https://customer-assets.emergentagent.com/job_fashion-narrative-2/artifacts/b4zrck62_selected_13.png'
    ]
  },
  {
    id: 3,
    brandName: 'J&J Junior',
    brandUrl: 'https://www.jackjones.in/collections/junior',
    description: 'Creative direction and visual storytelling for emerging junior brand. Building distinct visual identity with focus on trend forward styling and commercial appeal.',
    images: [
      'https://customer-assets.emergentagent.com/job_fashion-narrative-2/artifacts/luirj53s_jjjunior_1.jpg',
      'https://customer-assets.emergentagent.com/job_fashion-narrative-2/artifacts/ywpisejw_jjjunior_3.jpg',
      'https://customer-assets.emergentagent.com/job_fashion-narrative-2/artifacts/yu25vexl_jjjunior_5.jpg',
      'https://customer-assets.emergentagent.com/job_fashion-narrative-2/artifacts/dyx3xpsj_jjjunior_6.jpg',
      'https://customer-assets.emergentagent.com/job_fashion-narrative-2/artifacts/kgzpp3jw_jjjunior_7.jpg'
    ]
  },
  {
    id: 4,
    brandName: 'Vero Moda Girl',
    brandUrl: 'https://www.veromoda.in/collections/vm-girls-new-in',
    description: 'Developing cohesive visual language for contemporary women\'s fashion. Creating styling systems that balance trend relevance with brand consistency.',
    images: [
      'https://customer-assets.emergentagent.com/job_fashion-narrative-2/artifacts/6bllri0a_VMGMarketing_1.jpg',
      'https://customer-assets.emergentagent.com/job_fashion-narrative-2/artifacts/ifixxo9a_VMGMarketing_2.jpg',
      'https://customer-assets.emergentagent.com/job_fashion-narrative-2/artifacts/qef4avwc_VMGMarketing_3.jpg',
      'https://customer-assets.emergentagent.com/job_fashion-narrative-2/artifacts/u13ou5zj_VMGMarketing_16.jpg',
      'https://customer-assets.emergentagent.com/job_fashion-narrative-2/artifacts/ohymak56_VMGMarketing_17.jpg'
    ]
  }
];

// Portfolio projects data - TEXT ONLY, NO IMAGES
export const projects = [
  {
    id: 1,
    name: 'Brand Campaigns',
    role: 'Creative Head',
    year: '2023',
    context: 'A strategic visual overhaul for emerging brands under Bestseller India, focusing on creating cohesive brand narratives across digital and offline channels.',
    approach: 'Developed a minimal, editorial styling language that emphasized product clarity while maintaining emotional resonance. Created repeatable visual systems that could scale across multiple brands.',
    outcome: 'Established a consistent visual identity that increased brand recognition and drove a 40% increase in e-commerce engagement.'
  },
  {
    id: 2,
    name: 'Seasonal Collections',
    role: 'Head Stylist',
    year: '2021',
    context: 'Led the visual direction for seasonal collection campaigns, translating global brand identity into locally relevant imagery.',
    approach: 'Created a styling framework that balanced contemporary trends with timeless appeal. Focused on natural settings and authentic moments rather than studio perfection.',
    outcome: 'The campaign achieved highest engagement rates in brand history and set new standards for visual consistency across all touchpoints.'
  },
  {
    id: 3,
    name: 'Celebrity Campaign Series',
    role: 'Stylist',
    year: '2019',
    context: 'Styled national advertising campaigns featuring prominent personalities, ensuring visual coherence with brand narratives.',
    approach: 'Collaborated closely with directors and creative teams to develop character-driven wardrobes that felt authentic rather than styled. Balanced celebrity presence with product focus.',
    outcome: 'Campaigns received widespread acclaim and demonstrated how celebrity partnerships could enhance rather than overshadow brand identity.'
  },
  {
    id: 4,
    name: 'E-commerce Visual Standards',
    role: 'Creative Head',
    year: '2022',
    context: 'Established comprehensive visual guidelines for e-commerce product photography across multiple brands.',
    approach: 'Created a systematic approach to product presentation that prioritized clarity, consistency, and efficiency without sacrificing aesthetic appeal.',
    outcome: 'Reduced production time by 30% while improving visual quality and consistency across 1000+ monthly product shots.'
  },
  {
    id: 5,
    name: 'Film Styling, Feature Production',
    role: 'Senior Stylist',
    year: '2018',
    context: 'Contributed to wardrobe development for Dharma Productions feature film, supporting lead stylist in creating authentic character narratives.',
    approach: 'Deep research into character backgrounds, extensive sourcing, and meticulous attention to continuity. Balanced aesthetic appeal with narrative authenticity.',
    outcome: 'Film received critical acclaim for its authentic and nuanced costume design, contributing to character depth and storytelling.'
  }
];
